import React, { useState, useEffect } from 'react';
import { Magnifier } from 'react-image-magnifiers';

const ImageWithThumbnails = ({thumbImage, thumbnails}) => {
  const [mainImage, setMainImage] = useState(null); // Initialize with null
  console.log(thumbImage, thumbnails)
  useEffect(() => {
    thumbImage && setMainImage(thumbImage)
    if (thumbnails && thumbnails.length > 0) {
        thumbnails && setMainImage(thumbnails[0]); // Set the first thumbnail as the default
    }
  }, [thumbnails, thumbImage]);

  if (!mainImage) {
    return <div>Loading...</div>; // Show loading message while the image is being set
  }

  return (
    <>
    {mainImage && 
    <div style={{ textAlign: 'center' }}>
      <div style={{ marginBottom: '20px' }}>
      {mainImage &&
        <img
          src={mainImage}
          width={600}
          height={400}
        />
        }
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', width: '95%' }}>
      {thumbnails && thumbnails.map((thumbnail, index) => (
          <img
            key={index}
            src={thumbnail}
            alt={`Thumbnail ${index + 1}`}
            width={100}
            height={75}
            style={{
              cursor: 'pointer',
              border: '2px solid #ddd',
              borderRadius: '5px',
              transition: 'transform 0.3s',
              objectFit: 'cover'
            }}
            onClick={() => thumbnail && setMainImage(thumbnail)} // Change main image on click
            onMouseEnter={() => thumbnail && setMainImage(thumbnail)} // Change main image on hover
            onMouseLeave={() => thumbnails && setMainImage(thumbnail)} // Reset to default main image
          />
        ))}
      </div>
    </div>
    }
    </>
  );
};

export default ImageWithThumbnails;
